function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategories = function SvgCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.66248 4.65576H22.0125M8.66248 12.6658H22.0125M8.66248 20.6758H22.0125M2.65505 1.98584H5.32505C5.6937 1.98584 5.99255 2.28469 5.99255 2.65334V5.32334C5.99255 5.69199 5.6937 5.99084 5.32505 5.99084H2.65505C2.2864 5.99084 1.98755 5.69199 1.98755 5.32334V2.65334C1.98755 2.28469 2.2864 1.98584 2.65505 1.98584ZM2.65505 9.99585H5.32505C5.6937 9.99585 5.99255 10.2947 5.99255 10.6633V13.3333C5.99255 13.702 5.6937 14.0008 5.32505 14.0008H2.65505C2.2864 14.0008 1.98755 13.702 1.98755 13.3333V10.6633C1.98755 10.2947 2.2864 9.99585 2.65505 9.99585ZM2.65505 18.0057H5.32505C5.6937 18.0057 5.99255 18.3046 5.99255 18.6732V21.3432C5.99255 21.7119 5.6937 22.0107 5.32505 22.0107H2.65505C2.2864 22.0107 1.98755 21.7119 1.98755 21.3432V18.6732C1.98755 18.3046 2.2864 18.0057 2.65505 18.0057Z",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }));
};
export default SvgCategories;